import { Radio } from 'antd'
import classNames from 'classnames'
import { PretreatmentMethod } from '~/graphqls/types'

import styles from './PreProcessSelect.module.css'

export const options = [
  {
    name: '假涂鸦',
    id: PretreatmentMethod.FAKE_SCRIBBLE,
  },
  {
    name: '线稿涂鸦',
    id: PretreatmentMethod.SCRIBBLE,
  },
  {
    name: '无处理',
    id: PretreatmentMethod.INVERT_SCRIBBLE,
  },
]

interface Props {
  value?: string
  onChange?: (a: string) => void
}

export default function PreProcessSelect({ value, onChange }: Props) {
  return (
    <Radio.Group
      className="!flex justify-start flex-wrap !-ml-2"
      value={value}
      onChange={e => {
        onChange?.(e.target.value)
      }}
    >
      {options.map(item => {
        return (
          <Radio key={item.id} value={item.id} className={styles.customRadio}>
            <div
              className={classNames(
                'flex relative items-center justify-between cursor-pointer py-4 px-3 h-[36px] border-2 border-solid border-neutral-200 rounded-full flex-1 bg-neutral-200 min-w-[174px]',
                styles.radioBtn,
                styles.modelBg
              )}
            >
              <div className={classNames('flex-1 transition-all text-center')}>
                <div className="text-neutral-800 font-semibold">
                  {item?.name}
                </div>
              </div>
            </div>
          </Radio>
        )
      })}
    </Radio.Group>
  )
}
